import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import storage from "../assets/js/Global";
import { GlobalContext } from "../context/GlobalContext";
import { appconfig, urls } from "../urls/Url";

const api = axios.create({
    baseURL: appconfig.baseURL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: false,
});

let navigate;

export const setNavigate = (navigateFunction) => {
    navigate = navigateFunction;
};

const AxiosInterceptor = ({ children }) => {
    const navigateFunction = useNavigate();
    const { doLogout } = useContext(GlobalContext);

    useEffect(() => {
        setNavigate(navigateFunction);
    }, [navigateFunction]);

    api.interceptors.request.use(
        (config) => {
            config.headers = config.headers || {};
            const deviceId = storage.get("device_id");

            if (deviceId) {
                if (config.method === "get") {
                    config.params = { ...(config.params || {}), device_pid: deviceId };
                } else {
                    if (config.data instanceof FormData) {
                        if (config.headers && config.headers['Content-Type']) {
                            delete config.headers['Content-Type'];
                        }
                        config.data.append("device_pid", deviceId);
                    } else {
                        config.data = { ...(config.data || {}), device_pid: deviceId };
                    }
                }
            }

            if (!config.skipAuth) {
                const token = storage.get("accessToken");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
            }

            return config;
        },
        (error) => Promise.reject(error)
    );

    api.interceptors.response.use(
        (response) => response,
        async (error) => {
            const isLogoutRequest = error.config?.url?.includes(urls.logout);

            if (error.response?.status === 401 && !isLogoutRequest) {
                if (doLogout) {
                    await doLogout();
                } else {
                    const deviceId = storage.get("device_id");
                    localStorage.clear();
                    if (deviceId) storage.set("device_id", deviceId);
                }

                if (navigate) {
                    navigate("/login");
                }
            }

            return Promise.reject(error);
        }
    );

    return children;
};

export default AxiosInterceptor;
export { api };